export default __webpack_public_path__ + "static/media/featRaceBg.8b35430a.png";